import editorApi from '../api/editor';
export default {
    namespaced: true,
    state: {
        me : {}
    },
    getters: {
        getMe: (state)  => {
            return state.me
          },

    },
    mutations: {
        setMe(state,me) {
            state.me = me;
        },
    },
    actions: {
        getMe({commit}) {
            return new Promise((resolve, reject) => {
                editorApi.getMe().then(response => {
                    commit('setMe',response.data);
                    resolve(response.data);
                }, error => {
                    reject(error);
                })
            })
        }

        

    },
}